export default __webpack_public_path__ + "static/media/CardBG.79573ed2.png";